//********* TUTORIALS *********//
import * as types from "../../actions/actionTypes";

export const setAILoading = (aiLoading) => ({
  type: types.SET_AI_LOADING,
  payload: {aiLoading}
});

export const setAIResults = (aiResults) => ({
  type: types.SET_AI_RESULTS,
  payload: {aiResults}
});

export const setLookAiImageOpened = (lookAiImageOpened) => ({
  type: types.SET_LOOK_AI_IMAGE_OPENED,
  payload: {lookAiImageOpened}
});

export const setAiUserFileBlobUrl = (aiUserFileBlobUrl) => ({
  type: types.SET_AI_USER_FILE_BLOB_URL,
  payload: {aiUserFileBlobUrl}
});

export const setLookAiRenderFinished = (lookAiRenderFinished) => ({
  type: types.SET_LOOK_AI_RENDER_FINIHSED,
  payload: {lookAiRenderFinished}
});

export const setLookAiWaitingBoxClicked = (lookAiWaitingBoxClicked) => ({
  type: types.SET_LOOK_AI_WAITING_BOX_CLICKED,
  payload: {lookAiWaitingBoxClicked}
});

export const setLookAiImageExpanded = (aiImageExpanded) => ({
  type: types.SET_LOOK_AI_IMAGE_EXPANDED,
  payload: {aiImageExpanded}
});
